module.exports = __webpack_public_path__ + "img/bag.9fa3902f.png";